import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';
import { from } from 'rxjs';
import { DashboardContainerComponent } from './core-module/dashboard-container/dashboard-container.component'
import { AuthGuardService } from './authentication/auth/AuthGuard.service'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },{
    path:'',
    component: DashboardContainerComponent, 
    children: [{
        path: 'login',
        loadChildren: ()=> import('./authentication/login/login.module').then(m => m.LoginModule)
      },{
        path: 'registration',
        loadChildren: ()=> import('./authentication/registration/registration.module').then(m => m.RegistrationModule),
        canActivate: [AuthGuardService],
      },{
        path: 'dashboard',
        loadChildren: ()=> import('./core-module/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuardService],
      },{
        path: 'categories',
        loadChildren: ()=> import('./core-module/jewellery/jewellery.module').then(m => m.JewelleryModule),
        canActivate: [AuthGuardService],
      },{
        path: 'pd',
        loadChildren: ()=> import('./core-module/pd/pd.module').then(m => m.PDModule),
        canActivate: [AuthGuardService],
      },{
        path: 'pd/:id',
        loadChildren: ()=> import('./core-module/pd/pd.module').then(m => m.PDModule),
        canActivate: [AuthGuardService],
      },{
        path: 'analytics-dashboard',
        loadChildren: ()=> import('./core-module/analytics-dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuardService],
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'session/404'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
